// src/_Utils/utilsRatings.js
import apiRatings from "../_ApiConn/apiRatings";

const submitUserRating = async (restId, rating, comment = "") => {
    try {
        let result = await apiRatings.submitRating(restId, rating, comment);
        return result;
    } catch (error) {
        console.error("Error submitting rating:", error);
        return { success: false, error: error.message };
    }
}

const getUserRestaurantRating = async (restId) => {
    try {
        let result = await apiRatings.getUserRating(restId);
        return result;
    } catch (error) {
        console.error("Error getting user rating:", error);
        return null;
    }
}

const getRestaurantAverageRating = async (restId) => {
    try {
        let result = await apiRatings.getRestaurantRating(restId);
        return result;
    } catch (error) {
        console.error("Error getting restaurant rating:", error);
        return null;
    }
}

const getAllRestaurantReviews = async (restId) => {
    try {
        let result = await apiRatings.getAllReviews(restId);
        return result;
    } catch (error) {
        console.error("Error getting all reviews:", error);
        return [];
    }
}

export default {
    submitUserRating,
    getUserRestaurantRating,
    getRestaurantAverageRating,
    getAllRestaurantReviews
};